import axios from 'axios';
import environmentVariables from '../app/environmentVariables';

/**
 * GET `/getAdvertiserScreenInfo?screenId=` — single screen row (advertiser or admin JWT).
 */
export function getAdvertiserScreenInfo(token, screenId) {
  return axios.get(
    `${environmentVariables().REACT_APP_API_URL}/getAdvertiserScreenInfo?screenId=${encodeURIComponent(screenId)}`,
    {
      headers: {
        Authorization: `${token}`,
      },
    }
  );
}
